// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2KXbQ","footer":"ReportModalFilter_footer__2DtLd"};